import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ActivityIcon, HeartIcon, SparklesIcon, BrainIcon, ChevronLeftIcon, ChevronRightIcon, StarIcon, MessageSquareIcon } from 'lucide-react';
export function Home() {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const services = [{
    icon: ActivityIcon,
    title: 'Acupuncture',
    description: 'Traditional and specialized acupuncture techniques for holistic healing'
  }, {
    icon: HeartIcon,
    title: 'Fertility Treatment',
    description: 'Comprehensive fertility support using integrative TCM approaches'
  }, {
    icon: BrainIcon,
    title: 'Pain Management',
    description: 'Advanced protocols for chronic and acute pain relief'
  }, {
    icon: SparklesIcon,
    title: 'Cosmetic Acupuncture',
    description: 'Natural facial rejuvenation and Korean cosmetic techniques'
  }];
  const testimonials = [{
    name: 'Priya Sharma',
    condition: 'Fertility Treatment',
    text: "After years of trying, Dr. Kapoor's fertility acupuncture program helped us conceive naturally. We are forever grateful!",
    rating: 5
  }, {
    name: 'Rajesh Kumar',
    condition: 'Chronic Back Pain',
    text: 'The pain management protocols completely transformed my life. I can finally enjoy activities I thought were impossible.',
    rating: 5
  }, {
    name: 'Anita Desai',
    condition: 'Migraine Relief',
    text: 'My migraines have reduced by 90% after just 8 sessions. The integrative approach really works!',
    rating: 5
  }];
  const nextTestimonial = () => {
    setCurrentTestimonial(prev => (prev + 1) % testimonials.length);
  };
  const prevTestimonial = () => {
    setCurrentTestimonial(prev => (prev - 1 + testimonials.length) % testimonials.length);
  };
  return <div className="w-full" data-id="element-727">
      <section className="bg-gradient-to-br from-blue-50 via-white to-teal-50 py-20 px-4 w-full" data-id="element-728">
        <div className="max-w-7xl mx-auto" data-id="element-729">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-730">
            <div data-id="element-731">
              <div className="flex items-center space-x-4 mb-6" data-id="element-732">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8eURTgVqvsP8mr9gqSQeVQ/Logos.png" alt="AETHE Logo" className="h-20 w-20 object-contain" data-id="element-733" />
              </div>
              <h1 className="text-5xl font-bold text-gray-900 mb-6 leading-tight" data-id="element-734">
                Empowering Holistic Health Through Integrative Wisdom
              </h1>
              <p className="text-xl text-gray-600 mb-8" data-id="element-735">
                Experience the transformative power of Traditional Chinese
                Medicine combined with modern integrative approaches at AETHE.IN
              </p>
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-736">
                <Link to="/contact" data-id="element-737">
                  <button className="bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-blue-700 transition-colors shadow-lg" data-id="element-738">
                    Book Appointment
                  </button>
                </Link>
                <Link to="/education" data-id="element-739">
                  <button className="bg-white text-blue-600 px-8 py-4 rounded-lg font-semibold hover:bg-gray-50 transition-colors border-2 border-blue-600" data-id="element-740">
                    Enroll in Courses
                  </button>
                </Link>
              </div>
              <div className="mt-8 text-sm text-gray-600" data-id="element-741">
                <Link to="/about" className="text-blue-600 hover:underline font-medium" data-id="element-742">
                  Learn more about our mission →
                </Link>
              </div>
            </div>
            <div className="relative" data-id="element-743">
              <div className="bg-gradient-to-br from-blue-100 to-teal-100 rounded-3xl p-8 shadow-2xl" data-id="element-744">
                <img src="https://images.unsplash.com/photo-1559757175-5700dde675bc?w=800&h=600&fit=crop" alt="Acupuncture treatment" className="rounded-2xl shadow-lg w-full" data-id="element-745" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="py-16 px-4 bg-white w-full" data-id="element-746">
        <div className="max-w-7xl mx-auto" data-id="element-747">
          <div className="text-center mb-12" data-id="element-748">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-749">
              Our Core Services
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-750">
              Comprehensive integrative healthcare solutions combining ancient
              wisdom with modern techniques
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-751">
            {services.map((service, index) => <div key={index} className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow border border-gray-100" data-id="element-752">
                <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-4" data-id="element-753">
                  <service.icon className="w-7 h-7 text-blue-600" data-id="element-754" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-3" data-id="element-755">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-4" data-id="element-756">{service.description}</p>
                <Link to="/services" className="text-blue-600 font-medium hover:underline" data-id="element-757">
                  Learn more →
                </Link>
              </div>)}
          </div>
        </div>
      </section>
      <section className="py-16 px-4 bg-gradient-to-br from-blue-50 to-teal-50 w-full" data-id="element-758">
        <div className="max-w-7xl mx-auto" data-id="element-759">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-760">
            <div data-id="element-761">
              <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-762">
                Online Treatment Consultation
              </h2>
              <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-763">
                Get personalized treatment recommendations from the comfort of
                your home. Fill out our comprehensive health assessment form and
                upload your tongue picture and latest reports.
              </p>
              <div className="bg-white p-6 rounded-xl shadow-lg mb-6" data-id="element-764">
                <h3 className="font-semibold text-gray-900 mb-4" data-id="element-765">
                  How It Works:
                </h3>
                <div className="space-y-3" data-id="element-766">
                  <div className="flex items-start" data-id="element-767">
                    <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-3 flex-shrink-0 text-blue-600 font-semibold" data-id="element-768">
                      1
                    </div>
                    <p className="text-gray-700 text-sm" data-id="element-769">
                      Fill out the online treatment form with your health
                      details
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-770">
                    <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-3 flex-shrink-0 text-blue-600 font-semibold" data-id="element-771">
                      2
                    </div>
                    <p className="text-gray-700 text-sm" data-id="element-772">
                      Upload your latest tongue picture and medical reports
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-773">
                    <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-3 flex-shrink-0 text-blue-600 font-semibold" data-id="element-774">
                      3
                    </div>
                    <p className="text-gray-700 text-sm" data-id="element-775">
                      Receive personalized treatment recommendations via
                      WhatsApp
                    </p>
                  </div>
                </div>
              </div>
              <a href="https://treatment.aiimr.in/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center bg-green-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-green-700 transition-colors shadow-lg" data-id="element-776">
                <MessageSquareIcon className="w-5 h-5 mr-2" data-id="element-777" />
                Start Online Treatment Form
              </a>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-xl" data-id="element-778">
              <img src="https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=600&h=400&fit=crop" alt="Online consultation" className="rounded-xl mb-6" data-id="element-779" />
              <div className="bg-blue-50 p-4 rounded-lg" data-id="element-780">
                <p className="text-sm text-gray-700" data-id="element-781">
                  <span className="font-semibold" data-id="element-782">Note:</span> Our practitioners
                  will review your submission and provide detailed treatment
                  recommendations through WhatsApp within 24-48 hours.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="py-16 px-4 bg-white w-full" data-id="element-783">
        <div className="max-w-4xl mx-auto text-center" data-id="element-784">
          <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-785">
            Join Our Wellness Community
          </h2>
          <p className="text-gray-600 mb-8" data-id="element-786">
            Subscribe to our newsletter for expert TCM tips, seasonal wellness
            advice, exclusive offers, and early access to workshops and events.
            Plus, receive our free TCM Self-Care Acupressure Guide!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto" data-id="element-787">
            <input type="email" placeholder="Enter your email" className="flex-1 px-6 py-4 rounded-lg border-2 border-gray-200 focus:outline-none focus:border-blue-500" data-id="element-788" />
            <button className="bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-blue-700 transition-colors" data-id="element-789">
              Subscribe
            </button>
          </div>
          <p className="text-xs text-gray-500 mt-4" data-id="element-790">
            We respect your privacy. Unsubscribe anytime.
          </p>
        </div>
      </section>
      <section className="py-16 px-4 bg-gradient-to-br from-blue-50 to-teal-50 w-full" data-id="element-791">
        <div className="max-w-4xl mx-auto" data-id="element-792">
          <div className="text-center mb-12" data-id="element-793">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-794">
              Success Stories
            </h2>
            <p className="text-gray-600" data-id="element-795">Real results from our patients</p>
          </div>
          <div className="bg-white rounded-2xl shadow-xl p-8 relative" data-id="element-796">
            <button onClick={prevTestimonial} className="absolute left-4 top-1/2 -translate-y-1/2 p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors" data-id="element-797">
              <ChevronLeftIcon className="w-6 h-6 text-gray-700" data-id="element-798" />
            </button>
            <button onClick={nextTestimonial} className="absolute right-4 top-1/2 -translate-y-1/2 p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors" data-id="element-799">
              <ChevronRightIcon className="w-6 h-6 text-gray-700" data-id="element-800" />
            </button>
            <div className="px-12" data-id="element-801">
              <div className="flex justify-center mb-4" data-id="element-802">
                {[...Array(testimonials[currentTestimonial].rating)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-yellow-400 fill-current" data-id="element-803" />)}
              </div>
              <p className="text-xl text-gray-700 mb-6 text-center italic" data-id="element-804">
                "{testimonials[currentTestimonial].text}"
              </p>
              <div className="text-center" data-id="element-805">
                <p className="font-semibold text-gray-900" data-id="element-806">
                  {testimonials[currentTestimonial].name}
                </p>
                <p className="text-sm text-gray-600" data-id="element-807">
                  {testimonials[currentTestimonial].condition}
                </p>
              </div>
            </div>
            <div className="flex justify-center mt-6 space-x-2" data-id="element-808">
              {testimonials.map((_, index) => <button key={index} onClick={() => setCurrentTestimonial(index)} className={`w-2 h-2 rounded-full transition-colors ${index === currentTestimonial ? 'bg-blue-600' : 'bg-gray-300'}`} data-id="element-809" />)}
            </div>
          </div>
        </div>
      </section>
      <section className="py-16 px-4 bg-white w-full" data-id="element-810">
        <div className="max-w-4xl mx-auto text-center" data-id="element-811">
          <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-812">
            Download Your Free TCM Self-Care Guide
          </h2>
          <p className="text-gray-600 mb-8" data-id="element-813">
            Join our newsletter and receive expert tips, seasonal wellness
            advice, and exclusive offers
          </p>
          <div className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto" data-id="element-814">
            <input type="email" placeholder="Enter your email" className="flex-1 px-6 py-4 rounded-lg border-2 border-gray-200 focus:outline-none focus:border-blue-500" data-id="element-815" />
            <button className="bg-blue-600 text-white px-8 py-4 rounded-lg font-semibold hover:bg-blue-700 transition-colors" data-id="element-816">
              Subscribe
            </button>
          </div>
        </div>
      </section>
    </div>;
}